import React, { useState, useEffect, useRef } from 'react';

import groupAndRandomiseIcon from '../../../../../../../../../../../assets/img/groupandrandomise.png';

import styles from './GroupAndRandomiseParentHeader.module.css';
import ToggleSelector from '../../../../SidePropertiesContainer/components/ToggleSelector/ToggleSelector';

import arrowDown from '../../../../../../../../../../../assets/img/arrow-down.svg';

function GroupName({ setGroupNameRef, group, actions }) {
  const [changeName, setChangeName] = useState(false);

  return (
    <input
      ref={r => setGroupNameRef(r)}
      className={`${styles.groupName} ${
        changeName ? styles.changeGroupName : styles.blurGroupName
      }`}
      value={group.label}
      size={group.label ? group.label.length : 0}
      onChange={e =>
        actions.updateGroupProperty(group.id, 'label', e.target.value)
      }
      onFocus={e => {
        setChangeName(true);
        e.target.select();
      }}
      onBlur={e => {
        e.target.blur();
        e.target.selectionStart = 0;
        e.target.selectionEnd = 0;
        setChangeName(false);

        //
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === 'Tab') {
          e.preventDefault();
          e.target.blur();
        }
      }}
      placeholder="Add label - invisible to respondents"
    />
  );
}

export default function({ setGroupNameRef, group, actions }) {
  const [expandedShowGroupsDropdown, setExpandedShowGroupsDropdown] = useState(
    false
  );
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleOutsideDropdownClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setExpandedShowGroupsDropdown(false);
      }
    }

    document.addEventListener('click', handleOutsideDropdownClick);

    return () => {
      document.removeEventListener('click', handleOutsideDropdownClick);
    };
  }, []);

  const getShowAllGroupsOptions = () => {
    const options = [];

    // eslint-disable-next-line for-direction
    for (let i = group.flows.length; i > 0; i -= 1) {
      let label = '-';
      if (i === group.flows.length) {
        label = `Show all groups (${group.flows.length})`;
      } else if (i === 1) {
        label = `Show only 1 group`;
      } else {
        label = `Show ${i} groups`;
      }

      options.push({
        label,
        value: i === group.flows.length ? null : i
      });
    }

    return options;
  };

  const getShowAllGroupsLabel = () => {
    if (group) {
      if (group.showGroupAndRandomiseGroups === 1) {
        return `Show only 1 group`;
      }
      if (group.showGroupAndRandomiseGroups > 1) {
        return `Show ${group.showGroupAndRandomiseGroups} groups`;
      }

      return `Show all groups (${group.flows.length})`;
    }
    return '';
  };

  return (
    <div className={styles.container}>
      <img
        className={styles.icon}
        src={groupAndRandomiseIcon}
        alt="Group And Randomise Icon"
      />
      <GroupName
        setGroupNameRef={setGroupNameRef}
        group={group}
        actions={actions}
      />
      <div className={styles.randomizeToogleContainer}>
        <ToggleSelector
          label="Randomise groups"
          customParentStyle={styles.toogleSelector}
          customLabelStyle={styles.toogleSelectorLabel}
          labelPositionRight
          onChange={() =>
            actions.updateGroupProperty(
              group.id,
              'randomized',
              !group.randomized
            )
          }
          value={group.randomized}
        />
      </div>
      <div className={styles.showGroupsContainer}>
        <div
          className={styles.showGroupsContainerPlaceholder}
          role="presentation"
          onClick={() => {
            setExpandedShowGroupsDropdown(!expandedShowGroupsDropdown);
          }}
          ref={dropdownRef}
        >
          <img
            src={arrowDown}
            className={
              expandedShowGroupsDropdown ? styles.opened : styles.closed
            }
            alt="Open arrow"
          />
          {getShowAllGroupsLabel()}
        </div>
        {expandedShowGroupsDropdown ? (
          <div className={styles.showGroupsContainerDropdown}>
            {getShowAllGroupsOptions().map(o => (
              <div
                className={styles.item}
                role="presentation"
                onClick={e => {
                  e.stopPropagation();

                  actions.updateGroupProperty(
                    group.id,
                    'showGroupAndRandomiseGroups',
                    o.value
                  );
                }}
              >
                {o.label}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
